export default "__VITE_ASSET__FldioF3z__"